import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import StatusLabel from 'components/status-label/StatusLabel';
import { STATUS_LABEL_MAPPING } from '../realm-outfits-table/RealmOutfitsTable';

import { __t, applyTranslations } from 'utils/language';

import './outfit-review-header.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

type Props = {
  title: string,
  currentPosition: number,
  maxPosition: number,
  subTitle?: string | null,
  isEditMode: boolean,
  status?: string,
  onChangingCurrentPosition: (position: number) => void
};

const OutfitReviewHeader = ({
  title,
  subTitle,
  currentPosition,
  maxPosition,
  isEditMode,
  status,
  onChangingCurrentPosition
}: Props) => (
  <div className="outfit-review-header">
    {
      !isEditMode && (
        <SVGDynamicIcon
          name="chevron-left-custom-fg"
          width={16}
          height={16}
          customColor="grey"
          disabled={currentPosition === 0}
          clickable
          onClick={() => onChangingCurrentPosition(currentPosition - 1)}
        />
      )
    }
    <div className="outfit-review-header__title-container">
      <div className="outfit-review-header__title-container--title">{title}</div>
      {
        subTitle && (<div className="outfit-review-header__title-container--sub-title">{subTitle}</div>)
      }
      {
        status && (
          <StatusLabel
            size="nano"
            type={STATUS_LABEL_MAPPING[status]}
            label={__t(`collabary_common.status.${status}`)}
          />
        )
      }
    </div>
    {
      !isEditMode && (
        <SVGDynamicIcon
          name="chevron-right-custom-fg"
          width={16}
          height={16}
          customColor="grey"
          disabled={currentPosition === maxPosition}
          clickable
          onClick={() => onChangingCurrentPosition(currentPosition + 1)}
        />
      )
    }
  </div>
);

export default OutfitReviewHeader;
